import { render, staticRenderFns } from "./AppraisalsCard.vue?vue&type=template&id=22a2d870&scoped=true&"
import script from "./AppraisalsCard.vue?vue&type=script&lang=ts&"
export * from "./AppraisalsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2d870",
  null
  
)

export default component.exports